<template lang="html">
  <div class="xxx-gnb">
<!--    <NewIntercashCardsUsaFeesModal :enabled="true"></NewIntercashCardsUsaFeesModal>-->
<!--    <NewContactsPendingNewsModal :enabled="true"></NewContactsPendingNewsModal>-->
    <!-- crypto-news-modal-->
<!--    <walleto-kyc-reset-warning-modal></walleto-kyc-reset-warning-modal>-->
<!--    <walleto-terms-update2022-alert :enabled="walletoTermsUpdate"></walleto-terms-update2022-alert>-->
    <!--walleto-blocking-warning-modal-->
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import NewIntercashCardsUsaFeesModal
  from "@/views/pages/global/notices/cards/NewIntercashCardsUsaFeesModal.vue";

@Component({
  name: 'global-notices-block',
  components: {
    NewIntercashCardsUsaFeesModal
  },
})
export default class GlobalNoticesBlock extends Vue {
  @Prop({ default: false })
  walletoTermsUpdate: boolean
}
</script>

<style scoped lang="less">
.xxx-gnb {
  display: contents;
}
</style>
